/****************************************************************
 * WARNING THIS FILE IS AUTOGENERATED AND SHOULD NOT BE MODIFIED *
 ****************************************************************/
import * as React from "react"
import Svg from "@oui/system/Svg"
type DefaultProps = typeof defaultProps
type SvgProps = React.ComponentPropsWithoutRef<typeof Svg>
type Props = DefaultProps &
  Omit<SvgProps, "fill" | "height" | "stroke" | "viewBox" | "width">
const defaultProps = {
  label: "Camera",
  size: 20
}

const SvgCamera = ({ size, ...props }: Props) => (
  <Svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="currentcolor"
    stroke="currentcolor"
    {...props}
  >
    <circle fill="none" strokeWidth={1.1} cx={10} cy={10.8} r={3.8} />
    <path
      fill="none"
      d="M1 4.5c-.3 0-.5.2-.5.5v12c0 .3.2.5.5.5h18c.3 0 .5-.2.5-.5V5c0-.3-.2-.5-.5-.5h-5.5V2.9c0-.3-.2-.4-.5-.4H7c-.3 0-.5.1-.5.4v1.6H1h0z"
    />
  </Svg>
)

SvgCamera.defaultProps = defaultProps
export default SvgCamera
